// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"fa523047","213":"9e7bde2b","475":"87a6ef9a","580":"f9fa8a24","591":"f0938731","747":"9a57d74c"}[chunkId] + ".chunk.js";
};